import { title } from 'process';

const AUTH_ENDPOINT = process.env.REACT_APP_API_URL;

const ENDPOINT = process.env.REACT_APP_API_URL;

export const sample = (arr) => {
  return arr[Math.floor(Math.random() * arr.length)];
};

export const range = (start, end, step = 1) => {
  let output = [];
  if (typeof end === 'undefined') {
    end = start;
    start = 0;
  }
  for (let i = start; i < end; i += step) {
    output.push(i);
  }
  return output;
};

export const random = (min, max) =>
  Math.floor(Math.random() * (max - min)) + min;

export const goToNextLesson = (
  lessons,
  currLesson,
  setSelectedVideoId,
  setSelectedEpisodeNumber,
  setSelectedQuizId,
  setApiWasRequested,
  setRequestWasHandled,
  setExerciseWasRequested,
  setExerciseWasFetched
) => {
  var currLessonFound = false;
  var nextLesson = null;
  for (let i = 0; i < lessons.length; i++) {
    const candidateLesson = lessons[i];
    if (currLessonFound) {
      nextLesson = candidateLesson;
      break;
    }
    if (candidateLesson.episode_number === currLesson.episode_number) {
      currLessonFound = true;
    }
  }
  if (nextLesson) {
    if (nextLesson.episode_id) {
      setSelectedVideoId(nextLesson.episode_id);
      setSelectedEpisodeNumber(nextLesson.episode_number);
      setSelectedQuizId('');
      setApiWasRequested(true);
      setRequestWasHandled(false);
    } else {
      setSelectedQuizId(nextLesson.episode_number);
      setSelectedVideoId('');
      setSelectedEpisodeNumber('');
      setExerciseWasRequested(true);
      setExerciseWasFetched(false);
    }
  }
};

export const updateLessonCompleteEndpoint = (
  selectedCourse,
  sectionLookup,
  episodeNumber,
  newStatus,
  token
) => {

  const URL = ENDPOINT + `lesson-status`;

  const result = {
    course_id: selectedCourse,
    section_id: sectionLookup,
    lesson_id: episodeNumber,
    new_status: newStatus,
  };

  const HEADERS = {
    'Content-Type': 'application/json',
    Authorization: token,
  };
  const BODY = JSON.stringify(result);
  const request = new Request(URL, {
    method: 'PUT',
    headers: HEADERS,
    body: BODY,
    timeout: 100000,
  });
  fetch(request);
};

// NOTE: DO NOT DELETE
// export const updateOrder = async (course, sequence, token) => {
//   const modifiedSequence = sequence.map((item, index) => {
//     if (item.type === 'LESSON') {
//       return {
//         episode_number: item.episode_number,
//         status: item.status,
//         lesson_type: item.episode_id ? 'VIDEO' : 'EXERCISE',
//         type: 'lesson',
//         global_index: item.global_index,
//       };
//     } else if (item.type === 'SECTION') {
//       // Find the correct section index
//       let sectionIndex = 0;
//       for (let i = 0; i < index; i++) {
//         if (sequence[i].type === 'SECTION') {
//           sectionIndex++;
//         }
//       }

//       return {
//         section_index: sectionIndex,
//         title: item.id,
//         type: 'section',
//       };
//     }
//     return item;
//   });

//   const result = {};
//   let currentSectionKey = null;

//   modifiedSequence.forEach((item) => {
//     if (item.type === 'section') {
//       currentSectionKey = `${item.section_index}#${item.title}`;
//       result[currentSectionKey] = []; // Initialize an empty array for the section
//     } else if (item.type === 'lesson' && currentSectionKey) {
//       result[currentSectionKey].push(item);
//     }
//   });

//   const URL = AUTH_ENDPOINT + `course-sequence?key=${course}`;

//   const HEADERS = {
//     'Content-Type': 'application/json',
//     Authorization: token,
//   };
//   const BODY = JSON.stringify(result);
//   const request = new Request(URL, {
//     method: 'POST',
//     headers: HEADERS,
//     body: BODY,
//     timeout: 100000,
//   });
//   fetch(request);
// };
